import { AppContext } from "./AppContext";
import React, { useState } from "react";

const AppState = (props) => {
  const [currencySymbol, setCurrencySymbol] = useState(
    (localStorage.getItem("customer_currency") || "").replace(/"/g, "")
  );

return (
  <AppContext.Provider value={{ currencySymbol, setCurrencySymbol }}>
    {props.children}
  </AppContext.Provider>
);
};

export default AppState;